import { render, staticRenderFns } from "./ConversationMarker.vue?vue&type=template&id=2d5b6810&scoped=true&"
import script from "./ConversationMarker.vue?vue&type=script&lang=js&"
export * from "./ConversationMarker.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMarker.vue?vue&type=style&index=0&id=2d5b6810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b6810",
  null
  
)

export default component.exports